<div class="dialog">
    <h2 mat-dialog-title class="header">
      <span class="title">{{ 'supporter.dialog_title' | translate }}</span>
      <button class="close-ref" mat-icon-button (click)="close()" [title]="'general.close' | translate | titlecase">
        <mat-icon>clear</mat-icon>
      </button>
    </h2>
    <div mat-dialog-content>
        <div class="section-title">
            <mat-icon>info</mat-icon><h1>{{ 'supporter.supporter' | translate }}</h1>
        </div>
        <div class="section">
            <div class="general">
                <p>{{ 'supporter.general_description' | translate }}</p>
            </div>
            <div class="role">
                <h2>{{ 'supporter.role_title' | translate }}</h2>
                <p>{{ 'supporter.role_description' | translate }}</p>
            </div>
            <div class="register">
                <h2>{{ 'supporter.register_title' | translate }}</h2>
                <p>{{ 'supporter.register_description' | translate }}</p>
            </div>
            <div class="important">
                <h2>{{ 'supporter.important_title' | translate }}</h2>
                <p>{{ 'supporter.important_description' | translate }}</p>
            </div>
        </div>
    </div>
    <div mat-dialog-actions class="dialog-buttons-end">
        <!-- Button is made of <a> because the used giveaway website won't work as _blank otherwise -->
        <a 
            *ngIf="isSupporter" 
            class="close-ref confirm"
            mat-flat-button 
            [title]="'general.register' | translate | titlecase" 
            [ngClass]="{
                'disabled': !url
            }"
            [disabled]="!url" 
            href="{{url}}"
            target="_blank"
        >
            {{ 'general.register' | translate }}
        </a>
    </div>
</div>